import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../home/components/Navigation';
import { useApiClient } from '../../base/hooks/useApiClient';

export function NewPasswordPage() {
    const [newPassword, setNewPassword] = useState('');
    const [formError, setFormError] = useState<string | undefined>();
    const [successMessage, setSuccessMessage] = useState<string | undefined>();
    const [isLoading, setIsLoading] = useState(false);
    const apiClient = useApiClient();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        setIsLoading(true);

        const response = await apiClient.post('update-password', { token, newPassword });

        if (!response.ok) {
            const { error } = await response.json();
            setFormError(error);
            setIsLoading(false);
            return;
        }

        setSuccessMessage('Your password has been updated successfully.');
        setFormError(undefined);
        setIsLoading(false);

        setTimeout(() => {
            navigate('/login');
        }, 3000);
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 py-12 px-4 sm:px-6 lg:px-8">
            <button
                onClick={() => navigate('/')}
                className="absolute top-4 left-4 flex items-center text-white hover:text-indigo-100 transition-colors"
            >
                <ArrowLeft className="h-5 w-5 mr-2" />
                Back to Home
            </button>

            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8">
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold text-gray-900 mb-2">Set New Password</h2>
                    <p className="text-gray-600">Enter your new password below</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                    {formError && (
                        <p className="text-sm text-red-600 mb-2">
                            {formError}
                        </p>
                    )}
                    {successMessage && (
                        <p className="text-sm text-green-600 mb-2">
                            {successMessage}
                        </p>
                    )}
                    {!successMessage && (
                        <>
                            <div>
                                <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700 mb-2">
                                    New Password
                                </label>
                                <div className="relative">
                                    <input
                                        id="newPassword"
                                        type="password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        className="block w-full px-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        placeholder="Enter your new password"
                                        required
                                        disabled={isLoading}
                                    />
                                </div>
                            </div>

                            <Button primary className="w-full" disabled={isLoading}>
                                {isLoading ? 'Updating...' : 'Update Password'}
                            </Button>
                        </>
                    )}
                </form>
            </div>
        </div>
    );
}
